<template>
  <router-view />
</template>

<script>
export default {
  name: 'StorageIndex'
}
</script>
